const HomeBody = () => {
    return ( 
  <div className="homebody">
    <section className="u-clearfix u-section-1" id="sec-c9e9" style={{margin:"0% 5% 0%",paddingTop:'4%'}}>
      <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-xl u-sheet-1">
        <div className="u-container-style u-expanded-width u-group u-image u-radius-50 u-shape-round u-image-1" data-image-width="1500" data-image-height="1071" data-animation-name="customAnimationIn" data-animation-duration="2000">
          <div className="u-container-layout u-valign-middle u-container-layout-1">
            <h1 className="u-text u-text-1"> Easy Way to Find a Perfect Property</h1>
            <p className="u-text u-text-default u-text-2">.</p>
            <p className="u-text u-text-default u-text-3">Image from <a href="https://nigeriapropertycentre.com/" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-black u-btn-1">Freepik</a>
            </p>
            <div class="u-form u-grey-5 u-radius-20 u-form-1">
              <form  class="u-clearfix u-form-horizontal u-form-spacing-10 u-inner-form" source="email" name="form" style={{padding:"20px"}}>
                <div class="u-form-email u-form-group u-label-none">
                  <label for="email-3a86" class="u-label">Email</label>
                  <input type="email" placeholder="Enter a valid email address" id="email-3a86" name="email" class="u-border-none u-input u-input-rectangle u-radius-20" required="" />
                </div>
                <div class="u-align-left u-form-group u-form-submit u-label-none">
                  <a href=" " class="u-black u-border-none u-btn u-btn-submit u-button-style u-btn-2">Submit</a>
                </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-palette-1-light-3 u-section-2" id="sec-a5f7" style={{maxHeight:"60vh",padding:'10px'}}>
      <div className="u-clearfix u-sheet u-sheet-1">
        <div className="u-expanded-width u-layout-horizontal u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-1">
                <div className="u-image u-image-circle u-image-1" alt="" data-image-width="2250" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-1">Togo</h5>
                <p className="u-align-center u-text u-text-default u-text-2">10 Property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-2">
                <div className="u-image u-image-circle u-image-2" alt="" data-image-width="2250" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-3">Nigeria</h5>
                <p className="u-align-center u-text u-text-default u-text-4">40 Property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-3">
                <div className="u-image u-image-circle u-image-3" alt="" data-image-width="1500" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-5">Accra</h5>
                <p className="u-align-center u-text u-text-default u-text-6">34 property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-4">
                <div className="u-image u-image-circle u-image-4" alt="" data-image-width="2250" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-7">Kenya</h5>
                <p className="u-align-center u-text u-text-default u-text-8">20 Property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-5">
                <div className="u-image u-image-circle u-image-5" alt="" data-image-width="1006" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-9">South Africa</h5>
                <p className="u-align-center u-text u-text-default u-text-10">60 Property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-6">
                <div className="u-image u-image-circle u-image-6" alt="" data-image-width="1200" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-11"> Eygpt</h5>
                <p className="u-align-center u-text u-text-default u-text-12">56 Property</p>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-7">
                <div className="u-image u-image-circle u-image-7" alt="" data-image-width="2250" data-image-height="1500"></div>
                <h5 className="u-align-center u-text u-text-default u-text-13">Cameroon</h5>
                <p className="u-align-center u-text u-text-default u-text-14">60 Property</p>
              </div>
            </div>
          </div>
          <a className="u-absolute-vcenter u-black u-gallery-nav u-gallery-nav-prev u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-gallery-nav-1" href=" " role="button">
            <span aria-hidden="true">
              <svg viewBox="0 0 451.847 451.847"><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path></svg>
            </span>
            <span className="sr-only">
              <svg viewBox="0 0 451.847 451.847"><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path></svg>
            </span>
          </a>
          <a className="u-black u-gallery-nav u-gallery-nav-next u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-gallery-nav-2" href=" " role="button">
            <span aria-hidden="true">
              <svg viewBox="0 0 451.846 451.847"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path></svg>
            </span>
            <span className="sr-only">
              <svg viewBox="0 0 451.846 451.847"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path></svg>
            </span>
          </a>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-section-3" id="sec-5b34" style={{padding:"0px 40px"}}>
      <div className="u-clearfix u-sheet u-sheet-1">
        <h2 className="u-text u-text-default u-text-1"> Properties For Rent</h2>
        <p className="u-text u-text-default u-text-2">Image from <a href="https://nigeriapropertycentre.com/" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">Freepik</a>
        </p>
        <a href="https://nicepage.best" className="u-btn u-button-style u-btn-2">view more</a>
        <div className="u-expanded-width u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-container-style u-image u-image-round u-list-item u-radius-20 u-repeater-item u-image-1" data-image-width="2247" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-1">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-1">
                  <div className="u-container-layout u-valign-middle u-container-layout-2">
                    <h5 className="u-text u-text-default u-text-3"># 25,000,000</h5>
                    <p className="u-text u-text-4">Sample Pictures, click to connect</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-effect-hover-zoom u-image-round u-list-item u-radius-20 u-repeater-item u-list-item-2" data-image-width="1500" data-image-height="1000" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-background-effect u-expanded">
                <div className="u-background-effect-image u-expanded u-image u-image-2" data-image-width="1500" data-image-height="1000"></div>
              </div>
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-3">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-2">
                  <div className="u-container-layout u-valign-middle u-container-layout-4">
                    <h5 className="u-text u-text-default u-text-5"> # 55,000,000</h5>
                    <p className="u-text u-text-6"> Sample Pictures click to select</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="u-container-style u-image u-image-round u-list-item u-radius-20 u-repeater-item u-image-3" data-image-width="2250" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-5">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-3">
                  <div className="u-container-layout u-valign-middle u-container-layout-6">
                    <h5 className="u-text u-text-default u-text-7"> # 35,000,000</h5>
                    <p className="u-text u-text-8"> click for more pictures</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="u-container-style u-image u-image-round u-list-item u-radius-20 u-repeater-item u-image-4" data-image-width="2250" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-7">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-4">
                  <div className="u-container-layout u-valign-middle u-container-layout-8">
                    <h5 className="u-text u-text-default u-text-9"> # 25,000,000</h5>
                    <p className="u-text u-text-10"> click for more pictures</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="u-container-style u-image u-image-round u-list-item u-radius-20 u-repeater-item u-image-5" data-image-width="1200" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-9">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-5">
                  <div className="u-container-layout u-valign-middle u-container-layout-10">
                    <h5 className="u-text u-text-default u-text-11"> # 14,500,000</h5>
                    <p className="u-text u-text-12"> click for more pictures</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="u-container-style u-image u-image-round u-list-item u-radius-20 u-repeater-item u-image-6" data-image-width="1000" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-bottom u-container-layout-11">
                <div className="u-container-style u-expanded-width u-group u-radius-20 u-shape-round u-white u-group-6">
                  <div className="u-container-layout u-valign-middle u-container-layout-12">
                    <h5 className="u-text u-text-default u-text-13"> # 15,000,000</h5>
                    <p className="u-text u-text-14"> click for more pictures</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-section-4" id="sec-8360" style={{padding:"0px 40px"}}>
      <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <div className="u-clearfix u-expanded-width u-gutter-20 u-layout-wrap u-layout-wrap-1">
          <div className="u-layout">
            <div className="u-layout-row">
              <div className="u-container-style u-layout-cell u-palette-1-light-3 u-radius-40 u-shape-round u-size-30 u-layout-cell-1">
                <div className="u-container-layout u-valign-bottom u-container-layout-1">
                  <h2 className="u-text u-text-default u-text-1"> Let’s Find The Right Selling Option</h2>
                  <p className="u-text u-text-default u-text-2">Image from <a href="https://freepik.com" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">Freepik</a>
                  </p>
                  <div className="u-expanded-width u-list u-list-1">
                    <div className="u-repeater u-repeater-1">
                      <div className="u-container-style u-list-item u-repeater-item">
                        <div className="u-container-layout u-similar-container u-container-layout-2"><span className="u-align-left u-icon u-icon-circle u-palette-1-light-2 u-text-white u-icon-1" data-animation-name="customAnimationIn" data-animation-duration="2000">
                            <img src="images/svg/1.svg" alt="" />
                        </span>
                          <h5 className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-3"> Property Management</h5>
                          <p className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-4">Sample text. Click to select the Text Element.</p>
                        </div>
                      </div>
                      <div className="u-container-align-left u-container-style u-list-item u-repeater-item">
                        <div className="u-container-layout u-similar-container u-container-layout-3"><span className="u-align-left u-icon u-icon-circle u-palette-1-light-2 u-text-white u-icon-2" data-animation-name="customAnimationIn" data-animation-duration="2000">
                            <img src="images/svg/2.svg" alt="" />
                        </span>
                          <h5 className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-5"> Mortgage Services</h5>
                          <p className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-6">Sample text. Click to select the Text Element.</p>
                        </div>
                      </div>
                      <div className="u-container-align-left u-container-style u-list-item u-repeater-item">
                        <div className="u-container-layout u-similar-container u-container-layout-4"><span className="u-align-left u-icon u-icon-circle u-palette-1-light-2 u-text-white u-icon-3" data-animation-name="customAnimationIn" data-animation-duration="2000">
                            <img src="images/svg/3.svg" alt="" />
                        </span>
                          <h5 className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-7"> Currency Services</h5>
                          <p className="u-text u-text-default-lg u-text-default-md u-text-default-xl u-text-8">Sample text. Click to select the Text Element.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-align-center u-container-style u-image u-image-round u-layout-cell u-radius-40 u-size-30 u-image-1" data-image-width="1500" data-image-height="1500" data-animation-name="customAnimationIn" data-animation-duration="2000">
                <div className="u-container-layout u-container-layout-5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-palette-2-light-3 u-section-5" id="sec-f1df" >
      <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <div className="u-expanded-width u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-1">
                <h2 className="u-align-center u-text u-text-1" data-animation-name="counter" data-animation-event="scroll" data-animation-duration="3000">20k</h2>
                <h5 className="u-align-center u-text u-text-2">Award Winning</h5>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-2">
                <h2 className="u-align-center u-text u-text-3" data-animation-name="counter" data-animation-event="scroll" data-animation-duration="3000">14k</h2>
                <h5 className="u-align-center u-text u-text-4">Property Ready</h5>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-3">
                <h2 className="u-align-center u-text u-text-5" data-animation-name="counter" data-animation-event="scroll" data-animation-duration="3000">2m</h2>
                <h5 className="u-align-center u-text u-text-6">Happy Customer</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-section-6" id="carousel_ddcd" style={{padding:"0px 40px"}}>
      <div className="u-clearfix u-sheet u-sheet-1">
        <h2 className="u-text u-text-default u-text-1"> Explore Apartment Types</h2>
        <p className="u-text u-text-default u-text-2">Image from <a href="https://freepik.com" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">Freepik</a>
        </p>
        <a href="https://nicepage.best" className="u-btn u-button-style u-btn-2">view more</a>
        <div className="u-expanded-width u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-container-align-center u-container-style u-list-item u-palette-1-light-3 u-radius-20 u-repeater-item u-list-item-1" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-top-xl u-container-layout-1">
                <img alt='' className="u-expanded-width-lg u-expanded-width-md u-image u-image-round u-radius-20 u-image-1" src="images/pexels-photo-532568.jpeg" data-image-width="2250" data-image-height="1500" />
                <h5 className="u-align-center-sm u-align-center-xs u-text u-text-default u-text-3">Office</h5>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-palette-1-light-3 u-radius-20 u-repeater-item u-list-item-2" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-top-xl u-container-layout-2">
                <img alt='' className="u-expanded-width-lg u-expanded-width-md u-image u-image-round u-radius-20 u-image-2" src="images/house-isolated-field1.jpg" data-image-width="1500" data-image-height="1000" />
                <h5 className="u-align-center-sm u-align-center-xs u-text u-text-default u-text-4">House</h5>
              </div>
            </div>
            <div className="u-container-align-center u-container-style u-list-item u-palette-1-light-3 u-radius-20 u-repeater-item u-list-item-3" data-animation-name="customAnimationIn" data-animation-duration="2000">
              <div className="u-container-layout u-similar-container u-valign-top-xl u-container-layout-3">
                <img alt='' className="u-expanded-width-lg u-expanded-width-md u-image u-image-round u-radius-20 u-image-3" src="images/low-angle-shot-facade-white-modern-building-blue-clear-sky.jpg" data-image-width="1500" data-image-height="997" />
                <h5 className="u-align-center-sm u-align-center-xs u-text u-text-default u-text-5">Appartments</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-section-7" id="carousel_bac2" style={{padding:"0px 40px"}}>
      <div className="u-clearfix u-sheet u-sheet-1">
        <div className="u-clearfix u-expanded-width u-gutter-20 u-layout-wrap u-layout-wrap-1">
          <div className="u-layout">
            <div className="u-layout-row">
              <div className="u-container-align-center u-container-style u-image u-image-round u-layout-cell u-radius-40 u-size-30 u-image-1" data-image-width="4000" data-image-height="4000" data-animation-name="customAnimationIn" data-animation-duration="2000">
                <div className="u-container-layout u-container-layout-1"></div>
              </div>
              <div className="u-container-style u-layout-cell u-palette-1-light-3 u-radius-40 u-shape-round u-size-30 u-layout-cell-2">
                <div className="u-container-layout u-valign-middle u-container-layout-2">
                  <h2 className="u-align-left u-text u-text-default u-text-1"> Trusted By Best Exclusive Agents</h2>
                  <p className="u-align-left u-text u-text-2">Sample text. Click to select the Text Element.</p>
                  <ul className="u-align-left u-custom-font u-font-ubuntu u-spacing-20 u-text u-text-3">
                    <li> Find excellent deals</li>
                    <li>Friendly host &amp; Fast support</li>
                    <li>List your own property</li>
                  </ul>
                  <p className="u-align-left u-text u-text-4">Image from <a href="https://freepik.com" className="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">Freepik</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="u-align-center u-clearfix u-section-8" id="carousel_5b87" style={{padding:"0px 40px"}}>
      <div className="u-clearfix u-sheet u-sheet-1">
        <div className="u-expanded-width u-layout-horizontal u-list u-list-1">
          <div className="u-repeater u-repeater-1">
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-1">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-1" src="images/black-logo-1.png" alt="" data-image-width="151" data-image-height="158" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-2">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-2" src="images/black-logo-2_150.png" alt="" data-image-width="116" data-image-height="150" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-3">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-3" src="images/black-logo-3.png" alt="" data-image-width="168" data-image-height="156" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-4">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-4" src="images/black-logo-4.png" alt="" data-image-width="134" data-image-height="154" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-5">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-5" src="images/black-logo-5.png" alt="" data-image-width="142" data-image-height="155" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-6">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-6" src="images/black-logo-6.png" alt="" data-image-width="131" data-image-height="171" />
              </div>
            </div>
            <div className="u-align-center u-container-style u-list-item u-repeater-item">
              <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-7">
                <img className="u-image u-image-contain u-image-default u-preserve-proportions u-image-7" src="images/black-logo-8_150.png" alt="" data-image-width="148" data-image-height="150" />
              </div>
            </div>
          </div>
          <a className="u-absolute-vcenter u-black u-gallery-nav u-gallery-nav-prev u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-gallery-nav-1" href=" " role="button">
            <span aria-hidden="true">
              <img src="images/svg/4.svg" alt="4.svg" />
            </span>
            <span className="sr-only">
              <img src="images/svg/5.svg" alt="5.svg" />
            </span>
          </a>
          <a className="u-absolute-vcenter u-black u-gallery-nav u-gallery-nav-next u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-gallery-nav-2" href=" " role="button">
            <span aria-hidden="true">
              <img src="images/svg/6.svg" alt="" />
            </span>
            <span className="sr-only">
              <img src="images/svg/7.svg" alt="" />
            </span>
          </a>
        </div>
      </div>
    </section>
    <section className="u-clearfix u-white u-section-9" id="carousel_678b" style={{padding:"0px 40px",backgroundColor:'#eee'}}>
      <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-xl u-sheet-1">
        <div className="u-clearfix u-expanded-width u-gutter-20 u-layout-wrap u-layout-wrap-1">
          <div className="u-layout">
            <div className="u-layout-row">
              <div className="u-container-align-center u-container-style u-image u-image-round u-layout-cell u-radius-50 u-size-30 u-image-1" data-image-width="1500" data-image-height="1000" data-animation-name="customAnimationIn" data-animation-duration="2000">
                <div className="u-container-layout u-container-layout-1"></div>
              </div>
              <div className="u-container-style u-layout-cell u-palette-2-light-3 u-radius-50 u-shape-round u-size-30 u-layout-cell-2">
                <div className="u-container-layout u-valign-middle u-container-layout-2">
                  <div className="u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-layout-grid u-list u-list-1">
                    <div className="u-repeater u-repeater-1">
                      <div className="u-container-align-left u-container-style u-list-item u-repeater-item u-shape-rectangle">
                        <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-3"><span className="u-align-left u-file-icon u-icon u-text-black u-icon-1"><img src="images/4338295-038f51b9.png" alt="" /></span>
                          <p className="u-align-left u-text u-text-1">Proin sed libero enim sed faucibus turpis. At imperdiet dui accumsan sit amet nulla facilisi morbi tempus. Ut sem nulla pharetra diam sit amet nisl. Enim nunc</p>
                          <h5 className="u-align-left u-text u-text-2">Celia Almeda</h5>
                        </div>
                      </div>
                      <div className="u-container-align-left u-container-style u-list-item u-repeater-item u-shape-rectangle">
                        <div className="u-container-layout u-similar-container u-valign-middle u-container-layout-4"><span className="u-align-left u-file-icon u-icon u-text-black u-icon-2"><img src="images/4338295-038f51b9.png" alt=""/></span>
                          <p className="u-align-left u-text u-text-3">Proin sed libero enim sed faucibus turpis. At imperdiet dui accumsan sit amet nulla facilisi morbi tempus. Ut sem nulla pharetra diam sit amet nisl.&nbsp;</p>
                          <h5 className="u-align-left u-text u-text-4">Frank Kinney</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        </div>
     );
}
 
export default HomeBody;